module.exports = __webpack_public_path__ + "static/icon-f4082c79d3dbfd6f6aac96d9d2d87129.png";